"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roleKey = void 0;
/** 全域角色代碼 → common.roles 的翻譯 key（SUPER_ADMIN → superAdmin） */
const roleKey = (role) => role.toLowerCase().replace(/_([a-z])/g, (_, c) => c.toUpperCase());
exports.roleKey = roleKey;
